import * as Yup from "yup"; // Asegúrate de importar Yup al principio del archivo

export function initialValues(fileScene) {
  return {
    idScene: fileScene?.idScene || "",
    title: fileScene?.title || "",
    description: fileScene?.description || "",
    isPublic: fileScene?.isPublic || true,
    file: fileScene?.file || null,
  };
}

export function validationSchema() {
  return Yup.object({
    idScene: Yup.string().required("El ID de la escena es obligatorio"),
    title: Yup.string().required("El título es obligatorio"),
    description: Yup.string(),
    isPublic: Yup.boolean(),
    file: Yup.mixed().required("El archivo es obligatorio"),
  });
}
